import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Materia } from '../Interfaces/materia.interface';
import { AuthenticatorService } from './authenticator.service';

@Injectable({
  providedIn: 'root'
})
export class MateriasService {

  private base_url: string = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private auth: AuthenticatorService,
  ) { }

  getMaterias(filter?: any): Observable<Materia[]> {

    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias`;

    if (filter) {
      const params = new HttpParams()
        .set('filter', JSON.stringify(filter));
      return this.http.get<Materia[]>(url_api, { params, headers });
    }

    return this.http.get<any[]>(url_api, { headers });
  }

  getMateriasPorClaves(claves: string[]): Observable<Materia[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias`;

    const filter = {
      where: {
        materia: {
          inq: claves
        }
      }
    };

    const params = new HttpParams()
      .set('filter', JSON.stringify(filter));

    return this.http.get<Materia[]>(url_api, { params, headers });
  }

  getMateriaPorId(id: string): Observable<Materia> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias/${id}`;
    return this.http.get<Materia>(url_api, { headers });
  }

  obtenerMateriasCarreraSemestre(carrera: number, reticula: number, semestre: number): Observable<Materia[]> {

    if (carrera == null ||
      reticula == null ||
      semestre == null) {
      return of([]);
    }
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias/${carrera}/${reticula}/${semestre}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }

  obtenerMateriasCarrera(carrera: number, reticula: number): Observable<Materia[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias/${carrera}/${reticula}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }

  obtenerMateriasCarreraCo(carrera: number, reticula: number): Observable<any[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias-co/${carrera}/${reticula}`;
    return this.http.get<any[]>(url_api, { headers });
  }

  obtenerMateriasDCO(clave: string): Observable<any[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/datos-materias/${clave}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }

  obtenerMateriasCO(clave: string): Observable<Materia[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias-co/${clave}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }

  obtenerMateriasArea(area: string): Observable<Materia[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias-area/${area}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }

  obtenerMateriasCarreraBP(periodo: string, carrera: number, reticula: number, semestre: number): Observable<Materia[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias-base-paralelos/${carrera}/${reticula}/${periodo}/${semestre}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }

  obtenerMateriasDocente(periodo: string, docente: string): Observable<Materia[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias-docente/${periodo}/${docente}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }


  obtenerMateriasAula(periodo: string, aula: string): Observable<Materia[]> {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias-aula/${periodo}/${aula}`;
    return this.http.get<Materia[]>(url_api, { headers });
  }

  createMateria(materia: Materia) {
    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias`;
    return this.http.post<Materia>(url_api, materia, { headers });
  }

  updateMateras(materias_carrera: Materia) {
    const headers = this.auth.headers;

    const url_api = `${this.base_url}/materias/${materias_carrera.materia}`;
    return this.http.patch<Materia>(url_api, materias_carrera, {
      headers,
    });
  }

  deleteMateras(materias_carrera: Materia) {
    const headers = this.auth.headers;

    const url_api = `${this.base_url}/materias/${materias_carrera.materia}`;
    return this.http.delete<Materia>(url_api, {
      headers,
    });
  }

  getMateriaInfoCarrea(clave_oficial : string) {

    const headers = this.auth.headers;
    const url_api = `${this.base_url}/materias-info-carrera/${clave_oficial}`;
    return this.http.get<any[]>(url_api, {headers,});

  }

}
